import { isEmpty, isNumeric } from './ValidForm';
import InputTypes from '../enums/InputTypes';
import Validations from '../../config/translations/Validations';

export default class BaseValidator {
    #inputs;

    get inputs() {
        return this.#inputs;
    }

    constructor(inputs) {
        this.#inputs = inputs ?? [];
    }

    setInputs(inputs) {
        this.#inputs = inputs;
    }

    valid(data) {
        let errors = {};
        this.#inputs.forEach((el) => {
            if (el?.type !== InputTypes.ARRAY) {
                if (el?.form?.validate?.required && isEmpty(data?.[el?.name])) {
                    errors[el?.name] = Validations.form.required.replace('{LABEL}', el['label']);
                } else if (!el?.form?.validate?.required && isEmpty(data?.[el?.name])) {
                    return errors;
                }

                if (!isEmpty(data?.[el?.name]) && !errors?.[el?.name]) {
                    const res = this.validTypes(el, data?.[el?.name]);
                    if (!isEmpty(res)) errors[el?.name] = res;
                }

                const min = el?.form?.validate?.min ?? 0;
                const max = el?.form?.validate?.max ?? 0;
                if (!errors?.[el?.name]) {
                    if (min > 0 && max > 0 && min === max && `${data?.[el?.name]}`.length !== max) {
                        errors[el?.name] = Validations.form.thisCharLength
                            .replace('{LABEL}', el?.label)
                            .replace('{VALUE}', max);
                    } else if (min > 0 && max > 0) {
                        if (
                            `${data?.[el?.name]}`.length < min ||
                            `${data?.[el?.name]}`.length > max
                        ) {
                            errors[el?.name] = Validations.form.maxAndMinCharLength
                                .replace('{LABEL}', el?.label)
                                .replace('{MIN}', min)
                                .replace('{MAX}', max);
                        }
                    } else if (min > 0 || max > 0) {
                        const strName = min > 0 ? 'min' : 'max';
                        const val = min > 0 ? min : max;
                        if (
                            (strName === 'min' && `${data?.[el?.name]}`.length < min) ||
                            `${data?.[el?.name]}`.length > max
                        ) {
                            errors[el?.name] = Validations.form?.[`${strName}CharLength`]
                                .replace('{LABEL}', el?.label)
                                .replace('{VALUE}', val);
                        }
                    }
                }
            } else {
                let res = this.validTypes(el, data?.[el?.name]);
                if (!isEmpty(res)) errors[el?.name] = res;
            }
        });

        return errors;
    }

    validTypes(input, value) {
        let msg = '';
        let vTeste = value;
        switch (input.type) {
            case InputTypes.INTEGER:
            case InputTypes.DOUBLE:
            case InputTypes.FLOAT:
                if (typeof vTeste === 'object') vTeste = value.id ?? 'a';

                if (!isNumeric(vTeste))
                    msg = Validations.form.format.replace('{LABEL}', input.label);
                break;
            case InputTypes.FILE:
                if (input.form.validate?.maxSize) {
                    let maxBytesSize = input.form.validate?.maxSize * 1048576;
                    if (value.size > maxBytesSize) {
                        msg = Validations.form.fileMaxLength
                            .replace('{LABEL}', input.label)
                            .replace('{VALUE}', input.form.validate?.maxSize);
                    }
                }
                break;
            case InputTypes.ARRAY:
                if (input.form.validate?.required && value.length <= 0) {
                    msg = Validations.form.minArrayLength.replace('{LABEL}', input.label);
                }

                break;
            default:
                break;
        }
        return msg;
    }
}
